import { LitElement, html, css } from 'lit';
import { msg,str } from '@lit/localize';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { accessibility,containers,grid,sidebar } from '../../utilities/styles';
import { cardLinks } from '../../utilities/accessibility';
import { EventManager } from '../../utilities/events';
import { arrowBack, arrow } from '../../utilities/icons';
import { dateToMaybeRange,currencyFormatter  } from '../../utilities/eventUtilities';
import { handle403s } from '../../utilities/AllInErrorHandling';
export class AllInListingsEventManager extends LitElement {
    static properties = {
        config_membership: { type: Object, reflect:true},
        membership: { type: Object},
        restUrl: { type: String },
        nonce: { type: String },
        pageSize: { type: Number },
        params: { type: Object },
        name: { type: String },
        events: { type: Array },
        total: { type: Number },
        type: { type: Array },
        types: { type: Array },
        accessibilities: { type: Array },
        hardlinks: { type: Object },
        memberAlreadySharedProfileText: { type: String },
        memberShareButtonTextForEvent: { type: String },
        memberShareModalTextForEvent: { type: String },
        languages: { type: Array },
        _baseurl: { type: String },
        _language: { type: String },
        _search: { type: String },
        _addressSearch: { type: String },
        _personalisation: { type: Object },
        _accessibility: { type: Array },
        _format: { type: String },
        _price: { type: String },
        _pageNumber: { type: Number },
        _type: { type: Array },
        _dates: { type: String },
        _start_date: { type: String },
        _end_date: { type: String },
        _orderSort: { type: String },
        _currentEvent: { state: true, type: String },
        _currentEventSidebar: { state: true, type: String },
        _events: { state: true, type: Array },
        _total: { state: true, type: Number },
        //Accept memberdata
    }

    constructor() {
        super();
    }

    async connectedCallback() {
        super.connectedCallback();
        this.membership = this.config_membership;
        this.config_membership = null;
        this.eventManager = new EventManager(this);
        this.eventManager.listen(`allin-navigation-${this.name}`, this._updateSidebar.bind(this));
        this.eventManager.listen(`allin-event-go-back-${this.name}`, this._handleGoBack.bind(this));
        this.eventManager.listen(`allin-events-filters-${this.name}`, this._setFilters.bind(this));
        this.eventManager.listen(`allin-change-page-${this.name}`, this._handleChangePage.bind(this));
        this.eventManager.listen('popstate', this._paramsFromPopState);
        if(this.params){
            this._search = this.params.search??'';
            this._addressSearch = this.params.addressSearch??'';
            //this._personalisation = this.params.personalisation??{};
            this._accessibility = this.params.accessibility?this.params.accessibility.split(','):[]; 
            this._filterCategory = this.params.filterCategory?this.params.filterCategory.split(','):this._accessibility;
            this._type = this.params.type?this.params.type.split(','):[];            
            this._dates = this.params.dates??'';
            this._start_date = this.params.start_date??this.params.from??'';
            this._end_date = this.params.end_date??this.params.to??'';
            this._pageNumber = this.params.pageNumber??1;
            this._currentEvent = this.params.currentEvent??'';
            this._events = this.events??[];
            this._price = this.params.price??'All';
            this._format = this.params.format?this.params.format.split(','):[];
            this._orderSort = this.params.orderSort??'asc';
            this._language = this.params.language??'en';
        }
        if(this.total){
            this._total = this.total;
        }
        this.formats = [
            {name:'Online', label:'Online'},
            {name:'InPerson', label:'In Person'},
            {name:'Hybrid', label:'Hybrid'}
        ];
        this.prices = [
            {name:'All',label:'All'},
            {name:'Paid',label:'Paid'},
            {name:'Free',label:'Free'}
        ]

        this.eventManager.initHistory(JSON.stringify({params:this.params}));
        if(this._currentEvent){
            this.legend.classList.add('hide');
        }
        this._baseurl = this.hardlinks['listings_events'];
        await this._fetchAllProvisions();
        cardLinks(this.shadowRoot);
    }

    _paramsFromPopState(e) {
        this._handleGoBack();
    }
    
    disconnectedCallback(){
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }

    _setDocumentTitle(title){
        document.title = `${title} - All In`;
    }

    async firstUpdated(){
        if(!this._currentEvent&&!this._events.length){
            await this._fetchEvents();
        }
        if(!this.allProvisions){
            await this._fetchAllProvisions();
            this.requestUpdate();
        }
        cardLinks(this.shadowRoot);
        document.body.focus();
    }

    get grid(){
        return this.shadowRoot.querySelector('.grid.cards');
    }

    get legend(){
        return document.getElementById('legend');
    }

    async updated(changedProperties){
        if(changedProperties.has('params')){
            this._search = this.params.search??'';
            this._addressSearch = this.params.addressSearch??'';
            //this._personalisation = this.params.personalisation??{};
            if(typeof this.params.accessibility === 'string')
            {
                this.params._accessibility = this.params.accessibility?.split(',')
            }
            this._accessibility = this.params.accessibility?this.params.accessibility:[];
            if(typeof this.params.filterCategories === 'string'){
                this.params._filterCategories = this.params.filterCategories.split(',');
            }
            this._filterCategories = this.params.filterCategories?this.params.filterCategories:[];
            if(typeof this.params.type === 'string') {
                this._type = this.params.type?this.params.type.split(','):"";
            }
            this._type = this.params.type?this.params.type.split(','):[];           
            this._dates = this.params.dates??'';
            this._start_date = this.params.start_date??this.params.from??'';
            this._end_date = this.params.end_date??this.params.to??'';
            this._pageNumber = this.params.pageNumber??1;
            this._currentEvent = this.params.currentEvent??'';
            this._events = this.events??[];
            this._price = this.params.price??'All';
            if(typeof this.params.format === 'string'){
                this._format = this.params.format.split(',');
            }
            this._format = this.params.format?this.params.format.split(','):[];
            this._orderSort = this.params.orderSort??'asc';
            this._language = this.params.language??'en';
        }
        if(changedProperties.has('_currentEvent')){
            if(this._currentEvent){
                const eventSearchParams = new URLSearchParams();

                if(this._search) eventSearchParams.append('search', this._search);
                if(this._addressSearch) eventSearchParams.append('addressSearch', this._addressSearch);
                if(this._accessibility && this._accessibility.length) eventSearchParams.append('accessibility', this._accessibility.join(','));
                if(this._type && this._type.length) eventSearchParams.append('type', this._type.join(','));
                if(this._format) eventSearchParams.append('format', this._format);
                if(this._price) eventSearchParams.append('price', this._price);
                if(this._start_date) eventSearchParams.append('start_date', this._start_date);
                if(this._end_date) eventSearchParams.append('end_date', this._end_date);
                if(this._dates) eventSearchParams.append('dates', this._dates);
                if(this._language) eventSearchParams.append('language', this._language);
                if(this._pageNumber) eventSearchParams.append('pageNumber', this._pageNumber);
                if(this._orderSort && this._orderSort !== 'asc') eventSearchParams.append('orderSort', this._orderSort);

                const eventSearch = encodeURIComponent(eventSearchParams.toString());

                // this.eventManager.addHistory('/listings/events/'+this._currentEvent,{params:JSON.stringify({...this.params,currentEvent:this._currentEvent})});
                this.eventManager.addHistory(
                    `/listings/events/${this._currentEvent}?eventsearch=${eventSearch}`,{params:JSON.stringify({...this.params,currentEvent:this._currentEvent})}
                );
               
                
                //this.legend?.classList.add('hide');
                let eventData = this._events.find(ev=>ev.id === this._currentEvent);
                if(!eventData){
                    eventData = await this._fetchEventById(this._currentEvent);
                    this._events = [...this._events,eventData];
                }
                let locName = this._events.find(loc=>loc.id === this._currentEvent)?.name??'';
                this._setDocumentTitle(locName);
                this.eventManager.emit(`allin-header-${this.name}`,{name:this.name,text:locName});
                 let crumb = {
                    listing:{url:`${this._baseurl}`,title:msg(`Events`)},
                    panel:{url:`${this._baseurl}${this._currentEvent}`,title:locName}
                }
                this.eventManager.emit(`allin-breadcrumb-${this.name}`,crumb);
                let eventLocationsBlock = document.querySelector('#event-locations');
                eventLocationsBlock?.classList.remove('hide');
                this.eventManager.emit(`allin-event-locations-update`,{eventData:eventData});
                // Scroll to top of page when event page loads
                requestAnimationFrame(() => {
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    })
                })
                this.legend.classList.add('hide');
                this.renderRoot.querySelector('button,a')?.focus();
            }
            else{
                const params = new URLSearchParams();
                if(this._search) params.append('search', this._search);
                if(this._addressSearch) params.append('address1', this._addressSearch);
                if(this._personalisation) params.append('personalisation', JSON.stringify(this._personalisation));
                if(this._accessibility && this._accessibility.length) params.append('accessibility', this._accessibility.join(','));
                if(this._type && this._type.length) params.append('type', this._type.join(','));
                if(this._format) params.append('format', this._format);
                if(this._price) params.append('price',this._price);
                if(this._dates) params.append('dates', this._dates);
                if(this._language) params.append('language', this._language);
                if(this._start_date) {
                    params.append('start_date', this._start_date);
                    //params.append('from', this._start_date);
                }
                if(this._end_date) {
                    params.append('end_date', this._end_date);
                    //params.append('to', this._end_date);
                }
                if(this._pageNumber) params.append('pageNumber', this._pageNumber);
                this._setDocumentTitle('Events');

                this.eventManager.addHistory(`${this._baseurl}?${params.toString()}`,{params:JSON.stringify({...this.params,currentEvent:''})});
                this.eventManager.emit(`allin-header-${this.name}`,{name:this.name,revert:true});
                let crumb = {
                    listing:{url:`${this._baseurl}`,title:msg(`Events`)},
                }
                this.eventManager.emit(`allin-breadcrumb-${this.name}`,crumb);
                let eventLocationsBlock = document.querySelector('#event-locations');
                this.eventManager.emit(`allin-event-locations-update`,{eventData:null});
                eventLocationsBlock?.classList.add('hide');
                this.legend?.classList.remove('hide');
            }
        }
        
        cardLinks(this.shadowRoot);
    }

    render() {
        let main;
        let aside;
        let after;
        if(this._currentEvent){
            let eventData = this._events.find(ev=>ev.id === this._currentEvent);
            let icons = this._getAccessibilityIcons(eventData?.location?.provisions,true);
            if(!eventData){
                main=html`<allin-loader></allin-loader>`;
            }
            else{
                main=html`
                    <allin-event
                        event="${this._currentEvent}"
                        eventdata='${JSON.stringify(eventData)}'
                        location='${eventData?.location?.id??''}'
                        resturl="${this.restUrl}"
                        nonce="${this.nonce}"
                        name="${this.name}"
                        icons='${JSON.stringify(icons)}'
                        allprovisions='${JSON.stringify(this.allProvisions)}'
                        config_hardlinks=${JSON.stringify(this.hardlinks)}
                        .membership="${this.membership}"
                        memberAlreadySharedProfileText="${this.memberAlreadySharedProfileText}"
                        memberShareButtonTextForEvent="${this.memberShareButtonTextForEvent}"
                        memberShareModalTextForEvent="${this.memberShareModalTextForEvent}"
                    >
                    </allin-event>
                `; 
                /* console.log(this.hardlinks);
                after=html`
                    <allin-event-locations
                        event="${this._currentEvent}"
                        eventdata='${JSON.stringify(eventData)}'
                        location='${eventData?.location?.id??''}'
                        resturl="${this.restUrl}"
                        nonce="${this.nonce}"
                        name="${this.name}"
                        icons='${JSON.stringify(icons)}'
                        allprovisions='${JSON.stringify(this.allProvisions)}'
                        .hardlinks=${this.hardlinks}
                        .membership="${this.membership}"
                    >
                    </allin-event-locations>
                `; */
            }
            aside=html`<div>${this._currentEventSidebar}</div>`;
            return html`<div class="grid two_column">
            
                <aside class="sidebar">
                    
                    ${aside}
                </aside>
                <div class="content-wrapper">
                    ${main}
                </div>
            
            </div>
            `;
        }
        else{
            let cards = '';
            if(this._events.length){
                cards = this._events.map(event=>{
                
                    // Step 1: create an array for all provisions
                    let allProvisions = [];
                    let date = new Date();
                    // Step 2: loop through each instance
                   if (event.instances && event.instances.length) {
                        event.instances.forEach(instance => {
                            let start = new Date(instance.start);
                            let end = new Date(instance.end);
                            if(instance.end && end < date){
                                return;
                            }
                            else if (instance.start && start < date) {
                                return;
                            }
                            if (instance.provisions && instance.provisions.length) {
                                // add provisions to the array
                                allProvisions.push(...instance.provisions);
                            }
                        });
                    }
                    // Step 3: make provisions unique
                    allProvisions = [...new Set(allProvisions)];

                    // Step 4: get provisions from event instead of location
                    let icons = this._getAccessibilityIcons(allProvisions);

                    //let icons = this._getAccessibilityIcons(event?.location?.provisions);
                    let dateRange = dateToMaybeRange(event.firstInstance,event.lastInstance);
                    let locationName = event.location?.name??'';
                    //let locationLink = `/listings/locations/${event.location?.id??''}/events`;

                    const from = encodeURIComponent(window.location.pathname + window.location.search);
                    let locationLink = `/listings/locations/${event.location?.id ?? ''}/events?from=${from}`;
                    
                    if( !locationName && event.format == 'Online'){
                        locationName = msg(str`Online event`);
                        locationLink = '/listings/events?format=Online';
                    }
                    if( !locationName && event.format == 'Hybrid'){
                        locationName = msg(str`Hybrid event`);
                        locationLink = '/listings/events?format=Hybrid';
                    }
                    if(event.locationName){
                        locationName = event.locationName;
                        locationLink = event.locationUrl??'';
                    }
                    let priceHigh = event.priceRangeHigh??null;
                    let priceLow = event.priceRangeLow??null;
                    let priceString = '';
                    const eventUrl = `/listings/events/${event.id}`;
                    if(priceLow&&priceHigh===priceLow){
                        priceString = msg(str`${currencyFormatter.format(priceLow)}`);
                    }
                    else{
                        if(priceLow&&!priceHigh){
                            priceString = msg(str`From ${currencyFormatter.format(priceLow)}`);
                        }
                        else if(!priceLow&&priceHigh){
                            priceString = msg(str`Up to ${currencyFormatter.format(priceHigh)}`);
                        }
                        else if(priceLow&&priceHigh){
                            priceString = msg(str`${currencyFormatter.format(priceLow)} - ${currencyFormatter.format(priceHigh)}`);
                        }
                    }
                    if(priceString){
                        priceString = html`<p class="small"><strong>${msg(`Price:`)}</strong> ${priceString}</p>`;
                    }
                    else{
                        priceString = html`<p></p>`;
                    }
                    return html`
                    <div class="bg_white card card--event">
                        <div class="container container--threetwo">
                            <img src="${event.photo1?.publicUrl??'/wp-content/themes/ace/assets/fallback_new.jpeg'}" alt="${event.photo1?.altText??''}" />
                            <allin-alt-block description="${event.photo1?.altText??''}" uid="alt_photo1_${event.id}"></allin-alt-block>
                        </div>
                        <div class="card-content">
                            <a href="${eventUrl}" @click="${(e) => this._onEventClick(e, event.id)}" class="card_target"><h3>${event.name}</h3></a>
                            <p class="small"><strong>${msg(`Date:`)}</strong> ${dateRange}</p>
                            <p class="small"><strong>${msg(`Location:`)}</strong> <a href="${locationLink}" class="follow" >${locationName}</a></p>
                            ${priceString}
                            <ul class="accessibility-icons" aria-label="${msg(str`${icons.length} accessibility features`)}">
                                ${icons}
                            </ul>
                            ${arrow }
                        </div>
                    </div>`
                });
            }
            aside=html`<div class="sidebar">
            <allin-listings-filters
                name="${this.name}"
                show="checkboxes"
                listingtype="events"
                dates="${this._dates}"
                type='${JSON.stringify(this._type??[])}'
                start_date="${this._start_date}"
                end_date="${this._end_date}"
                price="${this._price}"
                format='${JSON.stringify(this._format??[])}'
                accessibility='${JSON.stringify(this._accessibility??[])}'
                accessibilities='${JSON.stringify(this.accessibilities??[])}'
                languages='${JSON.stringify(this.languages??[])}'
                language='${this._language??''}'
                types='${JSON.stringify(this.types??[])}'
                formats='${JSON.stringify(this.formats)}'
                prices='${JSON.stringify(this.prices)}'
                
            ></allin-listings-filters></div>`;
            main=html`
                <allin-listings-filters
                    name="${this.name}"
                    show="search"
                    total="${this._total??0}"
                    search="${this._search??''}"
                    addresssearch="${this._addressSearch??''}"
                    listingtype="events"
                    dates='${this._dates??''}'
                    format='${JSON.stringify(this._format??[])}'
                    price='${this._price??''}'
                    start_date='${this._start_date??''}'
                    end_date='${this._end_date??''}'
                    accessibilitylist='${JSON.stringify(this._accessibility??[])}'
                    accessibilities='${JSON.stringify(this.accessibilities??[])}'
                    language='${this._language??''}'
                    typelist='${JSON.stringify(this._type??[])}'
                    ordersort='${this._orderSort}'
                    types='${JSON.stringify(this.types??[])}'
                >
                </allin-listings-filters>
                <aside>${aside}</aside>
                <div class="grid grid_33 gap cards">
                    ${cards}
                </div>
                <allin-pagination
                    total="${this._total??0}"
                    currentpage="${this._pageNumber??1}"
                    pagesize="${this.pageSize??9}"
                    name="${this.name}"
                >
                </allin-pagination>
            `;
            return html`<div class="grid two_column">
                <slot name="above-main"></slot>
                ${main}
            </div>`;
        }
    }

    _updateSidebar(e){
        this._currentEventSidebar = e.detail.sidebar;
    }

    _handleGoBack(){
        this._currentEvent = '';
        this._currentEventSidebar = '';

        const params = new URLSearchParams();
        if(this._search) params.append('search', this._search);
        if(this._addressSearch) params.append('addressSearch', this._addressSearch);
        if(this._personalisation) params.append('personalisation', JSON.stringify(this._personalisation));
        if(this._accessibility && this._accessibility.length) params.append('accessibility', this._accessibility.join(','));
        if(this._type && this._type.length) params.append('type', this._type.join(','));
        if(this._format) params.append('format', this._format);
        if(this._price) params.append('price', this._price);
        if(this._start_date) params.append('start_date', this._start_date);
        if(this._end_date) params.append('end_date', this._end_date);
        if(this._dates) params.append('dates', this._dates);
        if(this._pageNumber) params.append('pageNumber', this._pageNumber);
        if(this._orderSort&&this._orderSort!=='asc') params.append('orderSort', this._orderSort);
        this.eventManager.addHistory(`/listings/events?${params.toString()}`);
        if(this.perpage) params.append('perpage', this.perpage);
        this._fetchEvents();
    }

    _selectEvent(event){
        this._currentEvent = event;
    }
    
    // A new selectEvent handler to allow normal link clicks and opening in a new tab
    _newSelectEvent(eventId) {
        // clear event-related state if needed
        this._currentEventSidebar = '';

        const params = new URLSearchParams();
        if(this._search) params.append('search', this._search);
        if(this._addressSearch) params.append('addressSearch', this._addressSearch);
        if(this._personalisation) params.append('personalisation', JSON.stringify(this._personalisation));
        if(this._accessibility && this._accessibility.length) params.append('accessibility', this._accessibility.join(','));
        if(this._type && this._type.length) params.append('type', this._type.join(','));
        if(this._format) params.append('format', this._format);
        if(this._price) params.append('price', this._price);
        if(this._start_date) params.append('start_date', this._start_date);
        if(this._end_date) params.append('end_date', this._end_date);
        if(this._dates) params.append('dates', this._dates);
        if(this._pageNumber) params.append('pageNumber', this._pageNumber);
        if(this._orderSort&&this._orderSort!=='asc') params.append('orderSort', this._orderSort);
        //this.eventManager.addHistory(`/listings/events?${params.toString()}`);
        if(this.perpage) params.append('perpage', this.perpage);

        this._currentEvent = eventId;
    }

    // New Event click handler to allow opening single events in a new tab
    _onEventClick(e, eventId) {
        // Kill cardLinks and any other delegated handlers
        if (
            e.defaultPrevented ||
            e.button !== 0 ||
            e.metaKey ||
            e.ctrlKey ||
            e.shiftKey ||
            e.altKey
        ) {
            return;
        }

        e.preventDefault();
        this._newSelectEvent(eventId);
    }

    _handleChangePage(e){
        const detail = e.detail;
        if('page' in detail && detail.page !== this._pageNumber){
            this._pageNumber = detail.page;
            this._fetchEvents();
        }
    }

    _setFilters(e){
        const detail = e.detail;
        let shouldFetch = false;
        if('search' in detail && detail.search !== this._search){
            this._search = detail.search;
            shouldFetch = true;
        }
        else if(this._search&&detail.show=='search'){
            this._search = '';
            shouldFetch = true;
        }
        if('addressSearch' in detail && detail.addressSearch !== this._addressSearch){
            this._addressSearch = detail.addressSearch;
            shouldFetch = true;
        }
        else if(this._addressSearch&&detail.show=='search'){
            this._addressSearch = '';
            shouldFetch = true;
        }
       /*  if('personalisation' in detail && JSON.stringify(detail.personalisation) !== JSON.stringify(this._personalisation)){
            this._personalisation = detail.personalisation;
            shouldFetch = true;
        } */
        if('accessibility' in detail && JSON.stringify(detail.accessibility) !== JSON.stringify(this._accessibility)){
            this._accessibility = detail.accessibility;
            if(!Array.isArray(this._accessibility)){
                this._accessibility = [this._accessibility];
            }
            shouldFetch = true;
        }
        else if(this._accessibility&&detail.show=='checkboxes'&&!('accessibility' in detail) ){
            this._accessibility = [];
            shouldFetch = true;
        }
        if('type' in detail && JSON.stringify(detail.type) !== JSON.stringify(this._type)){
            this._type = detail.type;
            if(!Array.isArray(this._type)){
                this._type = [this._type];
            }
            shouldFetch = true;
        }
        else if(this._type&&detail.show=='checkboxes'&&!('type' in detail)){
            this._type = [];
            shouldFetch = true;
        }
        if('dates' in detail){
            if(detail.dates !== this._dates){
                this._dates = detail.dates;
                // Preserve start_date if not part of detail
                if (!('start_date' in detail)) {
                    this._start_date = this._start_date;
                } else if ('start_date' in detail) {
                    this._start_date = detail.start_date;
                }
                // Preserve end_date if not part of detail
                if (!('end_date' in detail)) {
                    this._end_date = this._end_date;
                } else if ('end_date' in detail) {
                    this._end_date = detail.end_date;
                }
                shouldFetch = true;
            }
        }
        else if(this._dates&&detail.show=='checkboxes'&&!('dates' in detail)){
            this._dates = '';
            shouldFetch = true;
        }

        if('start_date' in detail){
            if(detail.start_date !== this._start_date) {
                this._start_date = detail.start_date;
                // Preserve end_date if not part of detail
                if (!('end_date' in detail)) {
                    this._end_date = this._end_date;
                } else if ('end_date' in detail) {
                    this._end_date = detail.end_date;
                }
                shouldFetch = true;
            }
        }
        else if(this._start_date&&detail.show=='checkboxes'&&!('start_date' in detail)){
            this._start_date = '';
            shouldFetch = true;
        }
        if('end_date' in detail){
            if(detail.end_date !== this._end_date) {
                this._end_date = detail.end_date;
                // Preserve start_date if not part of detail
                if (!('start_date' in detail)) {
                    this._start_date = this._start_date;
                } else if ('start_date' in detail) {
                    this._start_date = detail.start_date;
                }
                shouldFetch = true;
            }
        
        }
        else if(this._end_date&&detail.show=='checkboxes'&&!('end_date' in detail)){
            this._end_date = '';
            shouldFetch = true;
        }
        if('format' in detail && detail.format !== this._format){
            this._format = detail.format;
            if(!Array.isArray(this._format)){
                this._format = [this._format];
            }
            shouldFetch = true;
        }
        else if(this._format&&detail.show=='checkboxes'&&!('format' in detail) ){
            this._format = [];
            shouldFetch = true;
        }
        /*
        if('accessibility' in detail && JSON.stringify(detail.accessibility) !== JSON.stringify(this._accessibility)){
            this._accessibility = detail.accessibility;
            if(!Array.isArray(this._accessibility)){
                this._accessibility = [this._accessibility];
            }
            shouldFetch = true;
        }
        else if(this._accessibility&&detail.show=='checkboxes'&&!('accessibility' in detail) ){
            this._accessibility = [];
            shouldFetch = true;
        }
        */
        if('price' in detail && detail.price !== this._price){
            this._price = detail.price;
            shouldFetch = true;
        }
        if('pageNumber' in detail && detail.pageNumber !== this._pageNumber){
            this._pageNumber = detail.pageNumber;
            shouldFetch = true;
        }
        if('orderSort' in detail && detail.orderSort !== this._orderSort){
            this._orderSort = detail.orderSort;
            shouldFetch = true;
        }
        if('language' in detail && detail.language !== this._language){
            this._language = detail.language;
            shouldFetch = true;
        }
        if(JSON.stringify(detail) === "{}"||'reset' in detail){
            shouldFetch = true;
            this._search = '';
            this._addressSearch = '';
            this._accessibility = [];
            this._type = [];
            this._dates = '';
            this._start_date = '';
            this._end_date = '';
            //this._format = ["Online", "InPerson", "Hybrid"];
            this._format = [];
            this._price = 'All';
            this._pageNumber = 0;
            this._orderSort = 'asc';
            this._language = this.baseLanguage??'en';
        }
        if(shouldFetch){
            this._pageNumber = 1;
            this._fetchEvents();
            // // After completing emit, then scroll to the top of the emitted element
            // const container = document.querySelector('allin-listings-event-manager');
            // if (container) {
            //     window.scrollTo({
            //         top: 0,
            //         behavior: 'smooth'
            //     });
            //     // container.scrollIntoView({
            //     //     behavior: 'smooth',
            //     //     block: 'start'
            //     // });
            // }
        }
    }

    async _fetchAllProvisions(){
        try{
            const response = await fetch(`${this.restUrl}?action=get_all_provisions`,{
                headers: {
                    'AllIn-Nonce': this.nonce,
                    'AllIn-Public': 'public',
                }
            });

            //show logged out modal if session has expired
            if(response.status === 403){
                handle403s();
                return;
            }

            const data = await response.json();
            if(data){
                this.allProvisions = data.provisions??[];
            }
        }
        catch(error){
            console.error('Error fetching all provisions:', error);
        }

    }

    async _fetchEvents(){
        // Fetch events based on current filters
        const params = new URLSearchParams();
        if(this._search) params.append('search', this._search);
        if(this._addressSearch) params.append('addressSearch', this._addressSearch);
        if(this._personalisation) params.append('personalisation', JSON.stringify(this._personalisation));
        if(this._accessibility && this._accessibility.length) params.append('accessibility', this._accessibility.join(','));
        if(this._type && this._type.length) params.append('type', this._type.join(','));
        if(this._format) params.append('format', this._format);
        if(this._price) params.append('price', this._price);
        if(this._start_date) params.append('start_date', this._start_date);
        if(this._end_date) params.append('end_date', this._end_date);
        if(this._dates) params.append('dates', this._dates);
        if(this._pageNumber) params.append('pageNumber', this._pageNumber);
        if(this._language) params.append('language', this._language);
        if(this._orderSort&&this._orderSort!=='asc') params.append('orderSort', this._orderSort);
        this.eventManager.addHistory(`/listings/events?${params.toString()}`);
        if(this.perpage) params.append('perpage', this.perpage);
        // alert("Type:" + this._type.length);
        // alert("Accessibility: " + this._accessibility.length);
        try{
            this.grid?.classList.add('loading');
            const response = await fetch(`${this.restUrl}?action=get_events&${params.toString()}`,{
                headers: {
                    'AllIn-Nonce': this.nonce,
                    'AllIn-Public': 'public',
                }
            });

            //show logged out modal if session has expired
            if(response.status === 403){
                handle403s();
                return;
            }

            const data = await response.json();
            if(data){
                this._events = data.data??[];
                this._total = data.total??0;
                // After fetching event data, then scroll to the top of the updated 'allin-listings-event-manager'
                const container = document.querySelector('allin-listings-event-manager');
                if (container) {
                    container.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            }
        }
        catch(error){
            console.error('Error fetching events:', error);
        }
        finally{
            this.grid?.classList.remove('loading');
        }
    }

    async _fetchEventById(id){
        // Fetch a single event by ID (if not already in _events)
        const response = await fetch(`${this.restUrl}?action=get_event&event_id=${id}`,{
            headers: {
                'AllIn-Nonce': this.nonce,
                'AllIn-Public': 'public',
            }
        });

        //show logged out modal if session has expired
        if(response.status === 403){
            handle403s();
            return;
        }

        const data = await response.json();
        if(data){
            return data;
        }
        return null;
    }

    _getAccessibilityIcons(provisions,returnAsArray=false){
        let accessibilityIcons = [];
        let provisionMap = [];
        this.allProvisions?.forEach(prov=>{
            if(prov.provisions&&Array.isArray(prov.provisions)){
                provisionMap = [...provisionMap,...prov.provisions];
            }
            else{
                provisionMap.push(prov);
            }
        });
        if(provisions&&provisions.length){
            provisions.forEach(prov=>{
                let provision = provisionMap.find(p=>p.id===prov.standardId);

                if(provision?.filterCategory&&!accessibilityIcons.includes(provision?.filterCategory)){
                    accessibilityIcons.push(provision?.filterCategory);
                }
            });
        }
        accessibilityIcons.sort();
        if(returnAsArray){
            accessibilityIcons = accessibilityIcons.map(cat=>{
                let icon = this.accessibilities?.find(a=>a.name===cat);
                if(icon){
                    return {
                        label:icon.label,
                        icon:icon.icon
                    };
                }
            });
            return accessibilityIcons.filter(icon=>icon);
        }
        accessibilityIcons = accessibilityIcons.map(cat=>{
            let icon = this.accessibilities?.find(a=>a.name===cat);
            if(icon){
                return html`<li class="icon">
                    <span class="screen-reader-text">${msg(str`${icon.label}`)}</span>
                    <span aria-hidden="true">
                        ${unsafeHTML(icon.icon??'')}
                    </span>
                </li>`;
            }
        });
        accessibilityIcons = accessibilityIcons.filter(icon=>icon);
        return accessibilityIcons;
    }

    static styles = [
        accessibility,
        grid,
        containers,
        sidebar,
        css`
        
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            display:grid;
            gap:1rem;
        }
        .small{
            font-size:0.875rem;
        }


        h3,p{
            margin:0;
        }

        .button-group{
            display:flex;
            justify-content:space-between;
            margin-top:2rem;
        }

        .border-top{
            border-top:1px solid var(--allin-highlight-color,#472961);
            padding-top:2rem;
        }
        .button-group button, .return{
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            border:0;
            display:flex;
            gap:0.5rem;
            align-items:center;
            text-decoration:underline;
            cursor:pointer;
            transition:color var(--transition) ease;
            font-weight:700;
            font-size:1rem;

        }
        .return{
            padding:0;
            margin-bottom:2rem;
        }

        .button-group button svg, .return svg{
            transition:transform var(--transition) ease;
        }
        .button-group button:hover, .return:hover{
            text-decoration-thickness:2px;
        }
        
        .button-group button:hover svg, .return:hover svg{
            transform:rotate(15deg);
        }
        
        ul{
            list-style:none;
            padding:0;
            margin:0;
        }

        button.back{
            color:var(--allin-highlight-color,#472961);
            background-color:transparent;
            border:0;
            padding:0;
            font-weight:700;
            display:flex;
            align-items:center;
            gap:0.5rem;
        }
        button.back span{
            display:flex;
            align-items:center;
            justify-content:center;
            width:1rem;
        }
        button.back svg{
            transform:rotate(0);
            transition:transform var(--transition) ease;
            width:1rem;
        }
        button.back:hover{
            text-decoration:underline;
        }

        button.back:hover svg{
            transform:rotate(15deg);
        }
        @media (prefers-reduced-motion: reduce) {
            button.back svg{
                transform:none !important;
            }
        }
        
        @media (min-width: 1000px) {
            .two_column{
                grid-template-rows:auto auto auto auto auto;
                grid-auto-flow:dense;
                column-gap:4rem;
            }
            aside{ 
                grid-row:1 / -1;
                grid-column:2 / 3;
            }
        }

        .card{
            background-color:#fff;
            display:grid;
            grid-template-rows:auto 1fr;
            img{
                transition:opacity var(--transition) ease;
            }
        }

        .card .card-content>svg{
            transition:transform var(--transition) ease;
            display:block;
            margin-left:auto;
        }

        .card-content{
            padding:1rem;
        }

        .card a{
            color:var(--allin-highlight-color,#472961);
            text-decoration-gap:0.25rem;
            text-decoration-thickness:1px;
            transition:text-decoration-thickness var(--transition) ease;
        }
        .card {
            &:hover {
                a:first-child {
                text-decoration-thickness: 2px;
                }
            }

            a:not(:first-child):hover {
                text-decoration-thickness: 2px;
            }

            &:has(a:not(:first-child):hover) {
                a:first-child {
                text-decoration-thickness: 1px;
                }
            }
        }


        .card:hover .card-content>svg{
            transform:translateX(0.5rem);
        }

        @media (prefers-reduced-motion: reduce) {
            .card-content>svg{
                transform:none !important;
            }
        }

        .card-content{
            display:grid;
            grid-template-rows:auto auto auto 1fr auto;
        }

        .card.card--event .container{
            overflow: visible;
        }

        .accessibility-icons{
            display:flex;
            gap:0.75rem;
            margin:3rem 0;
            flex-wrap:wrap;
        }
        .accessibility-icons li{
            width:1.5rem;
            height:1.5rem;
            path,circle,rect,polygon{
                fill:var(--allin-highlight-color,#472961);
            }

        }

        .loading {
            position: relative;
        }

        .loading::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 2rem;
            height: 2rem;
            animation: spin 1s linear infinite;
            z-index: 100;
            background-image: url(/wp-content/themes/ace/assets/wheel.svg);
            background-size: cover;
        }

        @keyframes spin {
            from { transform: translate(-50%, -50%) rotate(0deg); }
            to   { transform: translate(-50%, -50%) rotate(360deg); }
        }

        .return{
            margin-top:1rem;
        }
        .return a{
            font-size: 1.25rem;
            font-weight: 700;
        }

        .grid.two_column .return.back-to-search a{
            text-decoration: none;
            color: #472961;
        }

        .grid--icon.return{
            margin:0;
        }

        .margin-bottom{
            margin-bottom:1rem;        
        }

        div.item.text p button.link-btn{
            font-weight: 700;
            transition: color var(--transition) ease;
            color: var(--allin-text-color, #472961);
            font-family: var(--allin-font-family, Montserrat, sans-serif);
            font-size: var(--allin-font-size, 1rem);
            padding: 0;
            border: none;
            text-align: left;
            background: transparent;
            cursor: pointer;
        }
        div.item.text p button.link-btn:hover{
            color: var(--allin-hover-color, #8141b9);
        }

        button.btn {
            padding: 1rem;
            border-radius: var(--allin-border-radius, 0.5rem);
            width: fit-content;
            text-align: center;
            font-family: var(--allin-font-family, Montserrat, sans-serif);
            font-size: var(--allin-font-size, 1rem);
            color: var(--allin-button-text-color, #fff);
            font-weight: (var(--allin-button-font-weight, 600));
            cursor: pointer;
            border: none;
            background: var(--allin-button-bg-color, #472961);
            transition: background var(--transition) ease;
        }
        button.btn:hover{
            background: var(--color-secondary-lighter-to-primary-lighter, #d3c9d7);
            color: rgb(52,52,52);

        .container img.contain{
            object-fit: contain;
        }
            
        `
        ];
}
